import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fill, minmax(min(100%, ${theme.spacing(37.5)}), 1fr))`,
  },

  card: {
    overflow: 'hidden',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
  },
}));
